<template>
  <p class="h200 text-neutral1000 px-3 py-2">
    {{ $t("global.choose_from_existing_list") }}
  </p>
</template>
